/* ============================================================
   NIORY THEME — Main JavaScript
   ============================================================ */

(function () {
  'use strict';

  /* ======================== CART STATE ======================== */
  let cartCount = 0;

  /* ======================== DOM READY ======================== */
  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    initMobileNav();
    initCartDrawer();
    initFAQ();
    initProductTabs();
    initProductGallery();
    initQuantityBreaks();
    initPurchaseTabs();
    initBundleBuilder();
    initScrollAnimations();
    initEmailPopup();
    initStickyATC();
    initFilterPills();
    initScrollToTop();
    updateCartCount();
  });

  /* ======================== SCROLL TO TOP ======================== */
  function initScrollToTop() {
    const btn = document.getElementById('scroll-to-top');
    if (!btn) return;
    window.addEventListener('scroll', function () {
      if (window.scrollY > 400) btn.classList.add('is-visible');
      else btn.classList.remove('is-visible');
    }, { passive: true });
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ======================== STICKY HEADER ======================== */
  function initHeader() {
    const header = document.querySelector('.site-header');
    if (!header) return;
    let lastScroll = 0;
    window.addEventListener('scroll', function () {
      const y = window.scrollY;
      if (y > 50) header.classList.add('scrolled');
      else header.classList.remove('scrolled');
      lastScroll = y;
    }, { passive: true });
  }

  /* ======================== FOCUS TRAP ======================== */
  const FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function trapFocus(container) {
    const els = Array.from(container.querySelectorAll(FOCUSABLE));
    if (!els.length) return;
    const first = els[0], last = els[els.length - 1];
    function handler(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
    container._trapHandler = handler;
    container.addEventListener('keydown', handler);
    first.focus();
  }

  function releaseFocus(container) {
    if (container._trapHandler) {
      container.removeEventListener('keydown', container._trapHandler);
      delete container._trapHandler;
    }
  }

  /* ======================== MOBILE NAV ======================== */
  function initMobileNav() {
    const btn = document.querySelector('.mobile-menu-btn');
    const nav = document.querySelector('.mobile-nav');
    const overlay = document.querySelector('.mobile-nav__overlay');
    const closeBtn = document.querySelector('.mobile-nav__close');
    if (!btn || !nav) return;

    btn.addEventListener('click', () => {
      nav.classList.add('is-open');
      trapFocus(nav);
    });
    const closeMobileNav = () => {
      nav.classList.remove('is-open');
      releaseFocus(nav);
      btn.focus();
    };
    overlay && overlay.addEventListener('click', closeMobileNav);
    closeBtn && closeBtn.addEventListener('click', closeMobileNav);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) closeMobileNav();
    });
  }

  /* ======================== CART DRAWER ======================== */
  function initCartDrawer() {
    const overlay = document.querySelector('.cart-overlay');
    const drawer = document.querySelector('.cart-drawer');
    const cartBtns = document.querySelectorAll('.cart-icon-btn, [data-open-cart]');
    if (!drawer) return;

    cartBtns.forEach(btn => btn.addEventListener('click', openCart));
    overlay && overlay.addEventListener('click', closeCart);

    // Use delegation so close button works even if DOM is re-rendered
    document.addEventListener('click', function (e) {
      if (e.target.closest('.cart-close')) closeCart();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeCart();
    });

    // Add to cart buttons
    document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
      btn.addEventListener('click', handleAddToCart);
    });

    // Quantity controls are handled by the cart-drawer section script via Shopify API
  }

  function openCart() {
    const ov = document.querySelector('.cart-overlay');
    const dr = document.querySelector('.cart-drawer');
    if (ov) ov.classList.add('is-open');
    if (dr) { dr.classList.add('is-open'); trapFocus(dr); }
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    const ov = document.querySelector('.cart-overlay');
    const dr = document.querySelector('.cart-drawer');
    if (ov) ov.classList.remove('is-open');
    if (dr) { dr.classList.remove('is-open'); releaseFocus(dr); }
    document.body.style.overflow = '';
  }

  function handleAddToCart(e) {
    // Sticky ATC delegates to the main button via initStickyATC — skip here
    if (e.currentTarget.classList.contains('sticky-atc__btn')) return;

    e.preventDefault();

    const btn = e.currentTarget;

    const variantIdEl   = document.getElementById('variant-id');
    const quantityEl    = document.getElementById('product-quantity');
    const sellingPlanEl = document.getElementById('selling-plan-field');

    const variantId   = variantIdEl   ? parseInt(variantIdEl.value,  10) : null;
    const quantity    = quantityEl    ? parseInt(quantityEl.value,   10) : 1;
    const sellingPlan = sellingPlanEl ? sellingPlanEl.value               : '';

    if (!variantId) { showToast('Please select a product option.'); return; }

    const originalText = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled    = true;

    const payload = { items: [{ id: variantId, quantity: quantity }] };
    if (sellingPlan) payload.items[0].selling_plan = sellingPlan;

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify(payload)
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      btn.textContent       = '✓ Added';
      btn.style.background  = 'var(--sage)';
      showToast('Added to your cart!');
      updateCartCount();
      if (typeof window.nioryRenderCart === 'function') window.nioryRenderCart();
      document.dispatchEvent(new CustomEvent('niory:cart:added'));
      openCart();
      setTimeout(function () {
        btn.textContent      = originalText;
        btn.style.background = '';
        btn.disabled         = false;
      }, 2000);
    })
    .catch(function () {
      btn.textContent = originalText;
      btn.disabled    = false;
      showToast('Could not add to cart. Please try again.');
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        cartCount = cart.item_count;
        updateCartCountDisplay(cartCount);
        updateShippingBar(cart.total_price);
      })
      .catch(() => {});
  }

  function updateCartCountDisplay(n) {
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = n;
      el.style.display = n > 0 ? 'flex' : 'none';
    });
  }

  function updateShippingBar(totalPrice) {
    const freeShipThreshold = 5000; // $50.00 in cents
    const fill = document.querySelector('.ship-bar__fill');
    const text = document.querySelector('.ship-bar__text');
    if (!fill || !text) return;
    const price = totalPrice || 0;
    const pct = Math.min(100, (price / freeShipThreshold) * 100);
    fill.style.width = pct + '%';
    if (text) {
      if (pct >= 100) {
        text.innerHTML = '🎉 You\'ve unlocked <strong>free shipping!</strong>';
      } else {
        const remaining = ((freeShipThreshold - price) / 100).toFixed(2);
        text.innerHTML = 'Spend <strong>$' + remaining + '</strong> more for free shipping';
      }
    }
  }

  /* ======================== FAQ ACCORDION ======================== */
  function initFAQ() {
    document.querySelectorAll('.faq-q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const item = btn.closest('.faq-item');
        const isOpen = item.classList.contains('open');
        // Close siblings
        const parent = item.closest('.faq-list, .faq-accordion');
        if (parent) {
          parent.querySelectorAll('.faq-item.open').forEach(other => {
            if (other !== item) other.classList.remove('open');
          });
        }
        item.classList.toggle('open', !isOpen);
      });
    });
  }

  /* ======================== PRODUCT TABS ======================== */
  function initProductTabs() {
    document.querySelectorAll('.product-tabs-nav').forEach(function (nav) {
      const buttons = nav.querySelectorAll('.product-tab-btn');
      const container = nav.closest('.product-tabs-wrap') || document;
      const panels = container.querySelectorAll('.product-tab-panel');

      buttons.forEach(function (btn, i) {
        btn.addEventListener('click', function () {
          buttons.forEach(b => {
            b.classList.remove('active');
            b.setAttribute('aria-selected', 'false');
          });
          panels.forEach(p => {
            p.classList.remove('active');
            p.setAttribute('hidden', '');
          });
          btn.classList.add('active');
          btn.setAttribute('aria-selected', 'true');
          if (panels[i]) {
            panels[i].classList.add('active');
            panels[i].removeAttribute('hidden');
          }
        });
      });
    });
  }

  /* ======================== PRODUCT GALLERY ======================== */
  function initProductGallery() {
    document.querySelectorAll('.product-gallery').forEach(function (gallery) {
      const mainImg = gallery.querySelector('.product-gallery__main img');
      const thumbs = gallery.querySelectorAll('.product-gallery__thumb');
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          thumbs.forEach(t => t.classList.remove('active'));
          thumb.classList.add('active');
          const src = thumb.querySelector('img') ? thumb.querySelector('img').src : thumb.dataset.src;
          if (mainImg && src) {
            mainImg.style.opacity = '0';
            setTimeout(() => {
              mainImg.src = src;
              mainImg.style.opacity = '1';
            }, 150);
          }
        });
      });
    });
  }

  /* ======================== QUANTITY BREAKS ======================== */
  function initQuantityBreaks() {
    document.querySelectorAll('.qty-break').forEach(function (option) {
      option.addEventListener('click', function () {
        const group = option.closest('.qty-break-list');
        if (group) group.querySelectorAll('.qty-break').forEach(o => o.classList.remove('selected'));
        option.classList.add('selected');
        const price = option.dataset.price;
        if (price) {
          const priceEl = document.querySelector('.product-pricing-row .price');
          if (priceEl) priceEl.textContent = '$' + price;
        }
      });
    });
  }

  /* ======================== PURCHASE TABS ======================== */
  function initPurchaseTabs() {
    document.querySelectorAll('.purchase-tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        const group = tab.closest('.purchase-tabs');
        if (group) group.querySelectorAll('.purchase-tab').forEach(t => t.classList.remove('active'));
        tab.classList.add('active');
        const type = tab.dataset.type;
        const priceEl = document.querySelector('.product-pricing-row .price');
        if (!priceEl) return;
        if (type === 'subscribe') {
          const subPrice = parseFloat(priceEl.textContent.replace('$', '')) * 0.85;
          priceEl.textContent = '$' + subPrice.toFixed(2);
        } else {
          const origPrice = priceEl.closest('.product-pricing-row').dataset.originalPrice;
          if (origPrice) priceEl.textContent = '$' + origPrice;
        }
      });
    });
  }

  /* ======================== BUNDLE BUILDER ======================== */
  function initBundleBuilder() {
    const sizeButtons = document.querySelectorAll('.bundle-size-btn');
    const productSelects = document.querySelectorAll('.bundle-prod');
    const summaryItems = document.querySelector('.bundle-summary__items');
    const totalEl = document.querySelector('.bundle-summary__total span:last-child');
    let maxSelections = 2;
    let selected = new Set();

    sizeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        sizeButtons.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        maxSelections = parseInt(btn.dataset.count) || 2;

        // Reset product selection when bundle size changes
        selected.clear();
        productSelects.forEach(function (p) { p.classList.remove('selected'); });

        // Clear premade bundle highlighting
        document.querySelectorAll('.premade-bundle').forEach(function (c) {
          c.style.borderColor = '';
          c.style.background = '';
        });

        updateBundleSummary();
      });
    });

    productSelects.forEach(function (prod) {
      prod.addEventListener('click', function () {
        const id = prod.dataset.productId;
        if (!id) return;
        if (selected.has(id)) {
          selected.delete(id);
          prod.classList.remove('selected');
        } else {
          if (selected.size < maxSelections) {
            selected.add(id);
            prod.classList.add('selected');
          } else {
            showToast('Remove a product first to swap it out');
            prod.classList.add('shake');
            setTimeout(() => prod.classList.remove('shake'), 400);
          }
        }
        updateBundleSummary();
      });
    });

    // Pre-made bundle click handler
    document.querySelectorAll('.premade-bundle').forEach(function (card) {
      card.addEventListener('click', function () {
        const ids = (card.dataset.products || '').split(',').map(s => s.trim()).filter(Boolean);
        if (!ids.length) return;

        // Update size selection
        maxSelections = ids.length;
        sizeButtons.forEach(function (b) {
          b.classList.toggle('active', parseInt(b.dataset.count) === maxSelections);
        });

        // Clear and re-select products
        selected.clear();
        productSelects.forEach(function (p) { p.classList.remove('selected'); });
        ids.forEach(function (id) {
          selected.add(id);
          const el = document.querySelector('[data-product-id="' + id + '"]');
          if (el) el.classList.add('selected');
        });

        // Highlight active premade card
        document.querySelectorAll('.premade-bundle').forEach(function (c) {
          c.style.borderColor = '';
          c.style.background = '';
        });
        card.style.borderColor = 'var(--navy)';
        card.style.background = 'var(--surface-blue)';

        updateBundleSummary();

        // Scroll to summary on mobile
        const summary = document.querySelector('.bundle-summary');
        if (summary && window.innerWidth < 900) {
          summary.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    function updateBundleSummary() {
      if (!summaryItems) return;
      const items = [];
      let basePrice = 0;
      selected.forEach(id => {
        const el = document.querySelector('[data-product-id="' + id + '"]');
        if (el) {
          const price = parseFloat(el.dataset.productPrice || '39.99');
          items.push({ name: el.dataset.productName || id, price: price });
          basePrice += price;
        }
      });
      if (items.length === 0) {
        summaryItems.innerHTML = '<p class="bundle-summary__empty">Select your patches above</p>';
      } else {
        summaryItems.innerHTML = items.map(item =>
          '<div class="bundle-summary__item"><span>' + item.name + '</span><span>$' + item.price.toFixed(2) + '</span></div>'
        ).join('');
      }
      let discount = 0;
      if (maxSelections === 2) discount = 0.10;
      if (maxSelections === 3) discount = 0.20;
      const discounted = basePrice * (1 - discount);
      const atcBtn = document.getElementById('bundle-atc');
      if (atcBtn) {
        if (selected.size === maxSelections) {
          atcBtn.disabled = false;
          atcBtn.textContent = 'Add Bundle to Cart — $' + discounted.toFixed(2);
        } else {
          atcBtn.disabled = true;
          atcBtn.textContent = 'Select ' + (maxSelections - selected.size) + ' More Patch' + (maxSelections - selected.size > 1 ? 'es' : '') + ' to Continue';
        }
      }
      if (totalEl) totalEl.textContent = '$' + discounted.toFixed(2);
      const originalEl = document.getElementById('bundle-original');
      const discountEl = document.getElementById('bundle-discount');
      if (originalEl) originalEl.textContent = selected.size ? '$' + basePrice.toFixed(2) : '—';
      if (discountEl) discountEl.textContent = selected.size ? '-$' + (basePrice * discount).toFixed(2) : '—';
    }
  }

  /* ======================== SCROLL ANIMATIONS ======================== */
  function initScrollAnimations() {
    const els = document.querySelectorAll('.animate-on-scroll');
    if (!els.length) return;

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          const delay = entry.target.dataset.delay || 0;
          setTimeout(() => entry.target.classList.add('visible'), parseInt(delay));
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    els.forEach(el => observer.observe(el));
  }

  /* ======================== EMAIL POPUP ======================== */
  function initEmailPopup() {
    const overlay = document.querySelector('.popup-overlay');
    const closeBtn = document.querySelector('.popup-close');
    const skipLink = document.querySelector('.popup__skip');
    const form = document.querySelector('.popup__form');
    if (!overlay) return;

    const dismissed = sessionStorage.getItem('niory-popup-dismissed');
    if (dismissed) return;

    const popupInner = overlay.querySelector('.email-popup');

    setTimeout(function () {
      overlay.classList.add('is-open');
      if (popupInner) trapFocus(popupInner);
    }, 4000);

    function closePopup() {
      overlay.classList.remove('is-open');
      if (popupInner) releaseFocus(popupInner);
      sessionStorage.setItem('niory-popup-dismissed', '1');
    }

    closeBtn && closeBtn.addEventListener('click', closePopup);
    skipLink && skipLink.addEventListener('click', closePopup);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closePopup();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closePopup();
    });

    form && form.addEventListener('submit', function (e) {
      e.preventDefault();
      const input = form.querySelector('.popup__input');
      const email = input ? input.value.trim() : '';
      if (!email) return;
      const submitBtn = form.querySelector('button[type="submit"]');
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Subscribing…'; }
      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          'form_type': 'customer',
          'utf8': '✓',
          'contact[email]': email,
          'contact[tags]': 'newsletter'
        }).toString()
      })
      .then(function () {
        showToast('Welcome! Your discount is on its way.');
        closePopup();
      })
      .catch(function () {
        showToast('Welcome! Your discount is on its way.');
        closePopup();
      });
    });
  }

  /* ======================== STICKY ATC ======================== */
  function initStickyATC() {
    const atc = document.querySelector('.sticky-atc');
    const actionsEl = document.querySelector('.product-actions');
    if (!atc || !actionsEl) return;

    const footerEl = document.querySelector('.site-footer');
    let pastActions = false;
    let footerVisible = false;

    function sync() {
      if (pastActions && !footerVisible) atc.classList.add('visible');
      else atc.classList.remove('visible');
    }

    const actionsObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        pastActions = !entry.isIntersecting;
        sync();
      });
    });
    actionsObserver.observe(actionsEl);

    if (footerEl) {
      const footerObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          footerVisible = entry.isIntersecting;
          sync();
        });
      }, { rootMargin: '0px 0px -1px 0px' });
      footerObserver.observe(footerEl);
    }

    atc.querySelector('.sticky-atc__btn') && atc.querySelector('.sticky-atc__btn').addEventListener('click', function () {
      const mainBtn = document.getElementById('atc-btn');
      if (mainBtn) mainBtn.click();
    });
  }

  /* ======================== FILTER PILLS ======================== */
  function applyFilter(filter) {
    document.querySelectorAll('.filter-scroll').forEach(function (row) {
      row.querySelectorAll('.filter-pill').forEach(function (pill) {
        pill.classList.toggle('active', pill.dataset.filter === filter || (!filter && pill.dataset.filter === 'all'));
      });
    });
    if (filter && filter !== 'all') {
      document.querySelectorAll('.product-card').forEach(card => {
        card.style.display = card.dataset.category === filter ? 'flex' : 'none';
      });
    } else {
      document.querySelectorAll('.product-card').forEach(card => {
        card.style.display = 'flex';
      });
    }
  }

  function initFilterPills() {
    const initial = new URLSearchParams(window.location.search).get('filter') || 'all';
    if (initial !== 'all') applyFilter(initial);

    document.querySelectorAll('.filter-scroll').forEach(function (row) {
      row.querySelectorAll('.filter-pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          const filter = pill.dataset.filter;
          applyFilter(filter);
          const url = new URL(window.location.href);
          if (filter && filter !== 'all') {
            url.searchParams.set('filter', filter);
          } else {
            url.searchParams.delete('filter');
          }
          history.pushState({ filter: filter }, '', url.toString());
        });
      });
    });

    window.addEventListener('popstate', function (e) {
      const filter = (e.state && e.state.filter) || new URLSearchParams(window.location.search).get('filter') || 'all';
      applyFilter(filter);
    });
  }

  /* ======================== TOAST ======================== */
  function showToast(msg) {
    let wrap = document.querySelector('.toast-wrap');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'toast-wrap';
      document.body.appendChild(wrap);
    }
    const toast = document.createElement('div');
    toast.className = 'toast';
    toast.textContent = msg;
    wrap.appendChild(toast);
    setTimeout(function () {
      toast.style.opacity = '0';
      toast.style.transition = 'opacity .3s ease';
      setTimeout(() => toast.remove(), 350);
    }, 2800);
  }

  /* ======================== SMOOTH SCROLL ======================== */
  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      const target = document.querySelector(link.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* ======================== ANALYTICS PLACEHOLDERS ======================== */
  // Meta Pixel / TikTok Pixel / GA4 — fire events on key actions
  window.nioryAnalytics = {
    track: function (event, data) {
      // Meta Pixel
      if (typeof fbq !== 'undefined') fbq('track', event, data);
      // TikTok
      if (typeof ttq !== 'undefined') ttq.track(event, data);
      // GA4
      if (typeof gtag !== 'undefined') gtag('event', event, data);
    },
    viewProduct: function (name, price) {
      this.track('ViewContent', { content_name: name, value: price, currency: 'USD' });
    },
    addToCart: function (name, price) {
      this.track('AddToCart', { content_name: name, value: price, currency: 'USD' });
    },
    initiateCheckout: function (value) {
      this.track('InitiateCheckout', { value: value, currency: 'USD' });
    }
  };

})();
